import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { posthog } from './posthog';
import { env } from '../../env';

export function PostHogPageviewTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!env.POSTHOG_KEY) return;
    posthog.capture('$pageview', {
      $current_url: window.location.href,
    });
  }, [location.pathname, location.search]);

  return <Outlet />;
}
